/*企业申报报表 */
import { $http, buildHeaders } from "./index";

//获取列表
export const taxdeclarereport_list = (params) => {
  return $http.get("/admin/TaxDeclareReport/index", { params });
};

//导出
export const taxdeclarereport_export = (params) => {
  return $http.get("/admin/TaxDeclareReport/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
